import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPeriod, setPeriod } from '../state/filtersSlice';
import { PERIOD_LABELS, Period } from '../utils/periods';
import './su-components.css';

export interface PeriodTabsProps {
  value?: Period;
  onChange?: (p: Period) => void;
}

const PeriodTabs: React.FC<PeriodTabsProps> = ({ value, onChange }) => {
  const dispatch = useDispatch();
  const sliceValue = useSelector((s: any) => selectPeriod(s));
  const picked = value ?? sliceValue;
  // Tabs are Today | WTD + MTD (value 'mtd'; the API returns WTD alongside it). Yesterday is shown on the Today cards.
  const current = picked === 'wtd' ? 'mtd' : picked;
  const tabs: Period[] = ['today', 'mtd'];
  return (
    <div className="su-periodtabs" role="tablist" aria-label="Period">
      {tabs.map((p) => (
        <button
          key={p}
          type="button"
          role="tab"
          aria-selected={p === current}
          className={`su-periodbtn${p === current ? ' active' : ''}`}
          onClick={() => {
            if (p === current) return;
            onChange ? onChange(p) : dispatch(setPeriod(p));
          }}
        >
          {p === 'mtd' ? 'WTD + MTD' : PERIOD_LABELS[p]}
        </button>
      ))}
    </div>
  );
};

export default PeriodTabs;
